import { ReactNode } from 'react';

interface MainContentProps {
    child: ReactNode;
    className?: string;
}

const MainContent = ({ child, className }: MainContentProps) => {
    return (
        <div
            className={`flex-1 ${className || ''} p-0 md:p-6 transition-all duration-300`}
        >
            {child}
        </div>
    );
};

export default MainContent;
